module.exports = __webpack_public_path__ + "images/orange.0e1cd5f707afb8ae5f43decd7c041102.png";